
import { defineComponent, computed, ref } from 'vue'
import { useAgreementModule } from '@/modules/agreements'
import { Member } from '@/modules/members'

export default defineComponent({
    name: 'agreement-form-field-new-member',
    emits: ['update:modelValue'],
    props: {
        modelValue: {
            type: String
        },
        agreementId: {
            type: String,
            required: true
        }
    },
    async setup (props) {
        const { getAgreementAvailableMembers, agreementAvailableMembers } = useAgreementModule()

        await getAgreementAvailableMembers(props.agreementId)

        const availableMembersOptions = computed(() => {
            return Object.values(agreementAvailableMembers.value).map((member: Member) => {
                return {
                    value: member.id,
                    label: `${member.firstName} ${member.lastName}`,
                    email: member.email
                }
            })
        })

        const filteredOptions = ref()

        const filterFn = (val: string, update: (arg: () => void) => void) => {
            update(() => {
                const needle = val.toLowerCase()
                filteredOptions.value = availableMembersOptions.value.filter(v => v.label.toLowerCase().indexOf(needle) > -1)
            })
        }

        const noAvailableMembers = computed(() => availableMembersOptions.value.length === 0)

        return {
            availableMembersOptions,
            noAvailableMembers,
            filterFn,
            filteredOptions
        }
    }
})
